















































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import AdminBrandId from "@/mixins/adminBrandId";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { ISegmentTypes } from "@/data/enums/segments";
import { ActionTypes } from "@/data/enums";
import { IMenuRoute } from "@/models/routes";

@Component({
  components: {
    "segments-provider": () =>
      import("@/components/app/admin/segments/segmentsProvider.vue"),
    "segments-list-view": () =>
      import("@/components/app/admin/segments/segmentsListView.vue")
  }
})
export default class AdminOrdersListView extends Mixins(AdminBrandId) {
  // Props
  @Prop({ default: () => [] })
  public routes!: any[];

  // Data
  public tableId = "OT1";
  public segmentType = ISegmentTypes.ORDER;

  public get defaultRoutes(): IMenuRoute[] {
    return [
      {
        label: this.$t("_.all"),
        to: {
          name: "adminOrders_all"
        }
      },
      {
        label: this.$t("_.paid"),
        to: {
          name: "adminOrders_paid"
        }
      },
      {
        label: this.$t("_.unpaid"),
        to: {
          name: "adminOrders_unpaid"
        }
      },
      {
        label: this.$t("_.cancelled"),
        to: {
          name: "adminOrders_cancelled"
        }
      },
      {
        label: this.$t("_.from_last_24_hours"),
        to: {
          name: "adminOrders_last_24_hours"
        }
      },
      {
        label: this.$t("_.from_last_7_days"),
        to: {
          name: "adminOrders_last_7_days"
        }
      },
      {
        label: this.$t("_.from_last_30_days"),
        to: {
          name: "adminOrders_last_30_days"
        }
      },
      {
        label: this.$t("_.pending_review"),
        to: {
          name: "adminOrders_preview"
        }
      },
      {
        label: this.$t("_.blocked"),
        to: {
          name: "adminOrders_blocked"
        }
      }
    ];
  }

  public get canCreateSegment() {
    return this.$userCan("create_segment");
  }

  public createOrderSegment(): void {
    if (!this.$userCan("create_segment")) return;
    this.$store.dispatch(
      `data/${DataModules.SEGMENTS}/openManageSegmentModal`,
      {
        props: {
          segmentType: this.segmentType,
          newSegmentRedirectRoute: "adminOrdersSegments",
          actionType: ActionTypes.CREATE
        }
      }
    );
  }
}
